interface FirebaseAuthStageEnvironment {
  appStage?: string;
  nodeEnv?: string;
  override?: string;
}

export const shouldUseProductionFirebaseAuth = ({
  appStage = process.env.APP_STAGE,
  nodeEnv = process.env.NODE_ENV,
  override = process.env.NEXT_PUBLIC_FIREBASE_AUTH_STAGE,
}: FirebaseAuthStageEnvironment = {}): boolean =>
  appStage === 'production' || (nodeEnv !== 'production' && override === 'production');
